import React from 'react';
import CuadroListaEditable from '../edicion/CuadroListaEditable.js';
import * as Data from '../edicion/data/DataEstadiosClubes.js';
import * as DTOs from '../edicion/DTOs/EstadiosClubesDTOs.js';
import * as Funciones from '../edicion/funciones/FuncionesEstadiosClubes.js';

const ClubesEstadio = (props) => {
  const idEstadio = props.estadio && props.estadio.id;
  const pais = props.estadio && props.estadio.pais;

  return (
    <CuadroListaEditable
      titulo="Clubes propietarios"
      idPadre={idEstadio}
      data={Data}
      dtos={DTOs}
      funciones={Funciones}
      contexto={{ pais: pais }}
    />
  );
};

export default ClubesEstadio;
